import { omit } from 'ramda'

import { SaleType, SaleTypeId } from 'app/dataTypes/dishes/saleType'

import { useCreateSaleType } from './useCreateSaleType'
import { useSaleTypesMain } from './useSaleTypesMain'
import { useModifySaleType } from './useModifySaleType'
import { useReplaceSaleType } from './useReplaceSaleType'


export function useSaleTypes() {
  const { saleTypesState, loading, setSaleTypesState } = useSaleTypesMain()

  const addSaleType = (st: SaleType) => {
    const { id } = st
    setSaleTypesState(saleTypesPrev => ({
      ...saleTypesPrev,
      [id]: st,
    }))
  }

  const removeSaleTypes = (removeIds: Array<SaleTypeId>) => {
    setSaleTypesState(omit(removeIds))
  }

  const createSaleType = useCreateSaleType(addSaleType)
  const modifySaleType = useModifySaleType(addSaleType)
  const replaceSaleTypes = useReplaceSaleType(removeSaleTypes)

  return {
    loading,
    createSaleType,
    modifySaleType,
    saleTypesState,
    replaceSaleTypes,
  }
}

export type SaleTypesContextType = ReturnType<typeof useSaleTypes>
